import { render, staticRenderFns } from "./SystemView.vue?vue&type=template&id=3ef1d04b&scoped=true"
import script from "./SystemView.vue?vue&type=script&lang=js"
export * from "./SystemView.vue?vue&type=script&lang=js"
import style0 from "./SystemView.vue?vue&type=style&index=0&id=3ef1d04b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef1d04b",
  null
  
)

export default component.exports